const state = {
  quizset: {}
}

const mutations = {
  setQuizset (state, quizset) {
    state.quizset = quizset
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
